export const ROUTES = {
  passportOrder: (artworkId: string) =>
    '/passport/order/new?artwork=' + encodeURIComponent(artworkId),
  passport: (passportId: string) => '/passport/' + encodeURIComponent(passportId),
  passportOrderStatus: (orderId: string) => '/passport/order/' + encodeURIComponent(orderId),
  passportTransfer: (transferId: string, token?: string) =>
    '/passport/transfer/' +
    encodeURIComponent(transferId) +
    (token ? '?token=' + encodeURIComponent(token) : ''),
  register: (redirect?: string) =>
    redirect ? '/auth/register?redirect=' + encodeURIComponent(redirect) : '/auth/register',
  passportConfirm: (requestId: string) => '/passport/confirm/' + encodeURIComponent(requestId),
  artistClaim: '/artist-claim',
  gallery: '/gallery',
  accountSecurity: '/account/security',
  about: '/about',
  howItWorks: '/how-it-works',
  terms: '/terms',
  privacy: '/privacy',
  sla: '/sla',
  acceptTerms: '/auth/accept-terms',
  dashboard: '/dashboard',
  dashboardArtworks: '/dashboard/artworks',
  dashboardArtwork: (artworkId: string) => '/dashboard/artworks/' + encodeURIComponent(artworkId),
  publicArtwork: (artworkId: string) => '/marketplace/' + encodeURIComponent(artworkId),
  adminArtworkChanges: '/admin/artwork-changes',
  adminTags: (query: string) => '/admin/tags?q=' + encodeURIComponent(query),
  tagUnlinked: (uuid: string) => '/tag/' + encodeURIComponent(uuid),
  tagRetired: (uuid: string) => '/tag/retired/' + encodeURIComponent(uuid),
  tagFailed: (reason: string) => '/tag/failed?reason=' + encodeURIComponent(reason),
} as const;

export const PENDING_PREFIXES = ['/artist-claim', '/gallery'] as const;
